import { Link } from 'react-router-dom';

export default function Button({ 
  children, 
  to, 
  href, 
  variant = 'primary', 
  className = '', 
  ...props 
}) {
  const baseStyles = "inline-flex items-center justify-center px-8 py-4 rounded-2xl font-bold transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 tracking-wide";
  
  const variants = {
    primary: "bg-blue-900 text-white hover:bg-blue-800 shadow-[0_10px_30px_-10px_rgba(30,58,138,0.5)] hover:shadow-[0_15px_35px_-10px_rgba(30,58,138,0.6)] hover:-translate-y-1 focus:ring-blue-900",
    secondary: "bg-white text-blue-900 shadow-[0_10px_30px_-10px_rgba(0,0,0,0.1)] hover:shadow-[0_15px_35px_-10px_rgba(0,0,0,0.15)] hover:-translate-y-1 focus:ring-blue-900",
    outline: "bg-transparent text-white border-2 border-white/30 hover:border-white hover:bg-white/10 focus:ring-white hover:-translate-y-1",
    ghost: "bg-transparent text-blue-900 hover:bg-blue-50 focus:ring-blue-900",
    accent: "bg-amber-500 text-white hover:bg-amber-600 shadow-[0_10px_30px_-10px_rgba(245,158,11,0.5)] hover:shadow-[0_15px_35px_-10px_rgba(245,158,11,0.6)] hover:-translate-y-1 focus:ring-amber-500"
  };

  const combinedClassName = `${baseStyles} ${variants[variant]} ${className}`;

  if (to) {
    return (
      <Link to={to} className={combinedClassName} {...props}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={combinedClassName} {...props}>
        {children}
      </a>
    );
  }

  return (
    <button className={combinedClassName} {...props}>
      {children}
    </button>
  );
}
